import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'; // Import useTranslation
import WrapperContent from "../../components/shared/WrapperContent";
import HeaderContent from "../../components/shared/HeaderContent";
import style from "../drivers/index.module.scss";
import PlusIcon from "../../components/shared/icons/PlusIcon";
import ModalConfirm from "../../components/shared/ModalWindow/Confirm";
import { Employee } from '../../services';
import Loading from '../../components/shared/Loading/Loading';
import EmptyContent from '../../components/shared/emptyContent';
import WorkersItemCard from '../../components/workers/WorkersItemCard';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useUserLimits } from '../../hooks/useClientLimits';
import AccessDeniedModal from '../../components/shared/SubscriptionModal/AccessDeniedModal';

const WorkersPage = () => {
    const { t } = useTranslation();
    const { user } = useSelector(state => state);
    const { employeeLimit } = useUserLimits();

    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setLoading] = useState(false)
    const [employee, setEmployee] = useState([])
    const [employeesTotal, setEmployeesTotal] = useState(0)
    const [isDisplayModal, changeDisplayModal] = useState(false);

    const companyId = user.companyId;

    const handleAddEmployeeClick = (e) => {
      const isUnlimited = user?.role?.isUnlimited === true;
      const remaining = Math.max(0, employeeLimit - employeesTotal);

      const canAddEmployee = isUnlimited || remaining > 0;

      if (!canAddEmployee) {
        e.preventDefault();
        changeDisplayModal(true);
      }

      if (user && !user.permissions?.includes("employer_add")) {
        e.preventDefault();
        toast.info(t('common.noAccessSupportMessage'), {
            autoClose: 10000
        });
      }
    };    

    const getEmployees = () => {
        Employee.getByEmployees(companyId, 1, 100).then(response => {
            if (response.data) {
                setEmployee(response.data.rows);
                setEmployeesTotal(response.data.total);
            }
        }).catch(err => {
            console.log('err', err);
        })
    }

    useEffect(() => {
        getEmployees()
    }, [])

    return (
      <div className={style.workers_wrapper}>
        <WrapperContent>
          <HeaderContent title={t('workersPage.header.title')} />
          {user.role !== "Employee" && (
            <div className={style.limit}>
              <Link
                to={"/workers/create"}
                className={style.button}
                onClick={handleAddEmployeeClick}
              >
                <PlusIcon />
                <span>{t('workersPage.buttons.add')}</span>
              </Link>
              {user && !user?.role?.isUnlimited && (
                <span className={style.limit__text}> Осталось: {Math.max(0, employeeLimit - employeesTotal)} </span>
              )}
            </div>
          )}
          <div className={style.itemsSort}>
            <span>{t('workersPage.countLabel', { count: employee.length })}</span>
          </div>
          <WorkersItemCard
            isHead
          />
          {isLoading && <Loading inBlock />}
          {employee.map((v, index) => <WorkersItemCard key={index} item={v} />)}
          {!isLoading && !employee.length && <EmptyContent />}
          {searchParams.get("created") === "1" && <ModalConfirm
            onClose={() => setSearchParams({ created: 0 })}
            title={t('workersPage.modal.addSuccess.title')}
            summary={<span>{t('workersPage.modal.addSuccess.summary')}</span>}
          />}

        </WrapperContent>
        {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
      </div>
    );
};

export default WorkersPage;
